import { Box, Loader } from '@wix/design-system';
import React from 'react';

interface UpgradeCompleteContentProps {
  isRedirecting: boolean;
}

export const UpgradeCompleteContent: React.FC<UpgradeCompleteContentProps> = ({ isRedirecting }) => {
  return (
    <Box height="100vh" width="100%" align="center" verticalAlign="middle">
      <Box direction="vertical" align="center" gap="24px">
        <Loader />
        <Box>{isRedirecting ? 'Redirecting to your dashboard...' : 'Processing upgrade completion...'}</Box>
      </Box>
    </Box>
  );
};
